<template>
  <div>
    <PortfolioProductsList
      :allocations="allocations"
      data-testid="portfolio-product-list"
      @product-click="openModal"
    />
    <ProductDetails
      v-show="isModalOpen"
      :is-open="isModalOpen"
      :instrument="instrument"
      data-testid="product-details"
      hide-right-button
      show-product-quotas
      @close="closeModal"
    />
  </div>
</template>

<script lang="ts" scoped>
import { Component, Vue, Prop } from 'vue-property-decorator';

import { ProductDetails } from '@/modules/products/components/ProductDetails';
import { PortfolioProductsList } from '@/modules/wealth/components/PortfolioProductsList';
import { IProductAllocation } from '@/modules/wealth/services/investment';

@Component({
  components: { PortfolioProductsList, ProductDetails }
})
export default class PortfolioProductsListWithDetails extends Vue {
  @Prop({ type: Array, required: true })
  readonly allocations!: IProductAllocation[];

  isModalOpen = false;

  private productApiId = '';

  get instrument() {
    return { apiId: this.productApiId };
  }

  openModal(productApiId: string) {
    this.productApiId = productApiId;
    this.isModalOpen = true;
  }

  closeModal() {
    this.isModalOpen = false;
  }
}
</script>
